export const toApiDateTime = (value) => {
  if (value === null || value === undefined || value === '') return null;

  const date = value instanceof Date ? value : new Date(String(value).trim());
  if (Number.isNaN(date.getTime())) return null;

  const pad = (part) => String(part).padStart(2, '0');

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
    + `T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

// Valores da API vem sem fuso ('2026-11-09T07:00:00'): sao horario local, nunca UTC.
const DATA_LOCAL_REGEX = /^(\d{4})-(\d{2})-(\d{2})(?:[T ](\d{2}):(\d{2})(?::(\d{2}))?(?:\.\d+)?)?$/;

export const parseDataLocal = (value) => {
  if (value === null || value === undefined || value === '') return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;

  const match = String(value).trim().match(DATA_LOCAL_REGEX);
  if (match) {
    const [, year, month, day, hour = 0, minute = 0, second = 0] = match.map(part => (part === undefined ? undefined : Number(part)));
    return new Date(year, month - 1, day, hour, minute, second);
  }

  const fallbackDate = new Date(String(value).trim());
  return Number.isNaN(fallbackDate.getTime()) ? null : fallbackDate;
};
